import React from 'react';
import { injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';

import { pipelineOptionFromEntity } from 'components/forms/autocomplete/Pipeline';
import { getLeadAssignmentStrategies } from 'helpers/leads';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormInput from 'components/forms/FormInput';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormHoldingCompany from 'components/forms/FormHoldingCompany';

class LeadAssignmentStrategyData extends EntityPropsUpdater {
  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      disabled,
      inModal,
      updateOwner,
      owner,
    } = this.props;

    return (
      <div className="clearfix">
        {entityLoaded && (
          <div>
            <Row>
              <Col xs={12} md={inModal ? 12 : 6}>
                <div className="panel panel-transparent">
                  <div className="panel-body">
                    <p>{messages.formGroup.basic_information}</p>

                    <div className="form-group-attached">
                      <FormInput
                        name="name"
                        label={messages.name}
                        value={entity.getName()}
                        meta={entity.getNameMetaInformation()}
                        validation={entity.getNameValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                      <FormHoldingCompany
                        onChange={updateOwner}
                        selectedClient={owner && owner.username}
                        disabled={disabled}
                        label={messages.company}
                      />
                      <FormAutocomplete
                        label={messages.pipeline}
                        name="pipeline"
                        value={pipelineOptionFromEntity(entity.getPipeline())}
                        meta={entity.getPipelineMetaInformation()}
                        validation={entity.getPipelineValidationResult()}
                        onChange={this.updateEntity}
                        returnValueObject
                        autocompleteType="pipeline"
                        disabled={disabled}
                      />
                      <FormAutocomplete
                        label={messages.strategy}
                        name="strategy"
                        value={entity.getStrategy()}
                        meta={entity.getStrategyMetaInformation()}
                        validation={entity.getStrategyValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                        options={getLeadAssignmentStrategies(messages)}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        )}
      </div>
    );
  }
}
LeadAssignmentStrategyData.defaultProps = {
  inModal: false,
};

export default injectIntl(LeadAssignmentStrategyData);
